/**
 * Route Segments & Constants
 * Centralized place for all path segment strings and types used throughout the application
 */

// ============================================================================
// Service Type Definition
// ============================================================================

export type ServiceType = 'admin' | 'tenant' | 'auth' | 'unknown';

// ============================================================================
// Default Sites
// ============================================================================

export const DEFAULT_SITES = {
  MEDIX: 'medix',
  SUPER_ADMIN: 'super-admin',
} as const;

// ============================================================================
// Route Segments - All path segments used in routes
// ============================================================================

export const ROUTE_SEGMENTS = {
  // Auth Segments
  ADMIN: 'admin',
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  PASSWORD: 'password',
  RESET: 'reset',

  // Admin Sections
  CLINICS: 'clinics',
  CLINIC_LOCATIONS: 'clinic_locations',
  CLINIC_INFORMATIONS: 'clinic_informations',
  CLINIC_USERS: 'clinic_users',
  CLINIC_LOCATION_MANAGERS: 'clinic_location_managers',
  CLINIC_LOCATION_MASSAGERS: 'clinic_location_massagers',
  MASSAGERS: 'massagers',
  INSURERS: 'insurers',
  INSURER_ATTENTIONS: 'insurer_attentions',
  HOSPITALS: 'hospitals',
  SPECIAL_CALCULATION_COSTS: 'special_calculation_costs',
  BANK_TRANSFERS: 'bank_transfers',
  REZEPT_HISTORIES: 'rezept_histories',
  INFORMATIONS: 'informations',
  DELETE_CLINICS: 'delete_clinics',

  // Tenant Sections
  PATIENTS: 'patients',
  CONSENTS: 'consents',
  R_CONSENTS: 'r_consents',
  REZEPTS: 'rezepts',
  REZEPT_APPLICATION_COUNTS: 'rezept_application_counts',
  VISITS: 'visits',
  SHEETS: 'sheets',
  TREATMENT_RECORDS: 'treatment_records',
  TREATMENT_RECORD_PRINT: 'treatment-record-print',
  FREE_MEDICAL: 'free_medical',
  MEDICAL_EXPENSE_PRICES: 'medical_expense_prices',
  DOCUMENT_TEMPLATES: 'document_templates',
  RECEIPT_PAPER_ORDER: 'receipt_paper_order',

  // Shared Patient Sub-routes
  HISTORIES: 'histories',
  DM_INFO: 'dminfo',
  LONG_TERM_FREQUENTS: 'long-term-frequents',
  CHECKIN_MAILS: 'checkin-mails',
  TREATMENT_REPORTS: 'treatment-reports',
  CERTIFICATION: 'certification',
  CONTINUATION: 'continuation',
  SEARCH_PATIENTS: 'search_patients',

  // Shared Sections
  EDIT: 'edit',
  CREATE: 'create',
  COPY: 'copy',
  DETAIL: ':id',

  // Other Routes
  DESIGN_TEMPLATE: 'design-template',
  CONTACT: 'contact',
  ORDER: 'order',
  SCHEDULE: 'schedule',
  TREATMENT_PERIOD: 'treatment_period',

  // Rezept Sub-routes
  RETURN_INIT: 'return_init',
  STATISTICAL_INIT: 'statistical_init',
  VISIT_CLINIC_INVOICES_INIT: 'visit_clinic_invoices_init',
  INVOICES_INIT: 'invoices_init',
  INIT_MASSAGERS: 'init_massagers',

  // Visit Sub-routes
  PATIENT_INIT: 'patient_init',
  MASSAGER_INIT: 'massager_init',
  VISITPATIENT_INIT: 'visitpatient_init',

  // Sheets Sub-routes
  ORDER_HISTORIES: 'order/histories',

  // Other Segments
  LIST: 'list',
  SERVER_ERROR: 'server-error',
} as const;

// ============================================================================
// External URL Segments
// ============================================================================

export const EXTERNAL_URL_SEGMENTS = {
  STORAGE: 'storage',
  MANUAL: 'manual',
  R2_MANUAL: 'r2_manual',
} as const;
